import * as allCookie from 'cookie'
const cookie = (allCookie as any).default || allCookie

export const parse = cookie.parse as typeof import('cookie').parse
export const serialize = cookie.serialize as typeof import('cookie').serialize

export default cookie
